// 转时间
function getDate (time) {
  if (!time) {
    return '-'
  }
  let _date = new Date(time)
  return _date.getFullYear() + '-' +　leftPad(_date.getMonth() + 1, 2) + '-' + leftPad(_date.getDate(), 2) + ' ' + leftPad(_date.getHours(), 2) + ':' + leftPad(_date.getMinutes(), 2) + ':' + leftPad(_date.getSeconds(), 2)
}
function leftPad (num, n) {
  var len = num.toString().length
  while (len < n) {
    num = '0' + num
    len++
  }
  return num
}

function formatDate (date, pattern) {
  if (!date) return date
  let SIGN_REGEXP = /([yMdHsm])(\1*)/g
  let DEFAULT_PATTERN = 'yyyy-MM-dd HH:mm:ss'
  if (/^\d+$/.test(date)) {
    date = new Date(+date)
  } else {
    if (typeof date === 'string') {
      date = new Date(date)
    }
  }
  pattern = pattern || DEFAULT_PATTERN
  return pattern.replace(SIGN_REGEXP, function ($0) {
    switch ($0.charAt(0)) {
      case 'y':
        return leftPad(date.getFullYear(), $0.length)
      case 'M':
        return leftPad(date.getMonth() + 1, $0.length)
      case 'd':
        return leftPad(date.getDate(), $0.length)
      case 'w':
        return date.getDay() + 1
      case 'H':
        return leftPad(date.getHours(), $0.length)
      case 'm':
        return leftPad(date.getMinutes(), $0.length)
      case 's':
        return leftPad(date.getSeconds(), $0.length)
    }
  })
}

export {
  getDate, formatDate
}
